export const VOLOP_URL_SEGMENTS_BY_LOCALE = {
  en: 'volunteer-opportunity',
  es: 'oportunidad-voluntariado',
  pt: 'oportunidade-voluntariado',
} as const satisfies Record<UserLocale, string>;

export const VOLOP_URL_SEGMENTS = Object.values(VOLOP_URL_SEGMENTS_BY_LOCALE);
